import moment from 'moment';

export const CalendarViewsConfig = {
    fourWeek: {
        type: "dayGrid",         // standard month/week grid
        duration: { weeks: 4 },  // exactly 4 weeks
        buttonText: "4 weeks",
        dateIncrement: { weeks: 1 }, // Navigate one week at a time
    }
}

export const GetDayCellContent = (arg) => {
    const dayDate = moment(arg.date).format('MMM D'); // e.g., "Oct 30", "Nov 5"
    
    return (
        <div className="w-full flex items-center px-1 gap-x-1">
            <div className='text-xxs 2xl:text-xs text-gray-800'>{dayDate}</div>
        </div>
    );
}

export const GetDayCellClassNames = (arg) => {

    const date = moment(arg.date);
    
    const today = moment().startOf('day');
    
    if (date.isBefore(today)) {
        return ['past-day'];
    }
    
    return [];

}

export const GetDayHeaderContent = (arg) => {
    const fullNames = {
        'Mon': 'Monday',
        'Tue': 'Tuesday',
        'Wed': 'Wednesday',
        'Thu': 'Thursday',
        'Fri': 'Friday',
        'Sat': 'Saturday',
        'Sun': 'Sunday'
    }

    return (
        <h2 className="text-center py-2 -my-[3px] text-sm 2xl:text-base">
            {fullNames[arg.text] || arg.text}
        </h2>
    );
}